export class SttStillInProgressError extends Error {
  constructor() {
    super(
      'Cannot regenerate text while it is still generating. Please wait until all text has been generated and try again.',
    )
    Object.setPrototypeOf(this, SttStillInProgressError.prototype)
  }
}
